<h2 lvrPadding [padHorizontal]="32" [padVertical]="0" id="client-career-heading">
	{{ 'client.career.edit_title' | transloco }}
</h2>
<form
	[formGroup]="form"
	lvrAutoSave="career"
	[entityId]="draftId()"
	[autoLoad]="false"
	aria-labelledby="client-career-heading"
>
	<lvr-section>
		<lvr-section-form>
			<!-- Date Field -->
			<lvr-field
				[label]="'client.career.date' | transloco | appendAsterisk"
				[matTooltip]="'client.career.date_hint' | transloco"
			>
				@let dateCtrl = form.get('date');
				<mat-form-field lvrInput [lvrError]="hasError(dateCtrl, 'required', 'maxDateExceeded', 'minDateExceeded')">
					<input
						matInput
						formControlName="date"
						[matDatepicker]="picker"
						placeholder="10.10.2025"
						[min]="minMaxDate.min"
						[max]="minMaxDate.max"
						[errorStateMatcher]="matcher"
					/>
					@if (hasError(dateCtrl, 'required')) {
						<mat-error>{{ 'client.career.error.required' | transloco }}</mat-error>
					}
					@if (hasError(dateCtrl, 'minDateExceeded')) {
						<mat-error>{{ 'client.career.error.minDateExceeded' | transloco: { min: minMaxDate.minYears } }}</mat-error>
					}
					@if (hasError(dateCtrl, 'maxDateExceeded')) {
						<mat-error>{{ 'client.career.error.maxDateExceeded' | transloco: { max: minMaxDate.maxYears } }}</mat-error>
					}
					<mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
					<mat-datepicker #picker></mat-datepicker>

					@if (dateCtrl?.disabled) {
						<mat-hint> {{ 'client.career.not_editable' | transloco }}</mat-hint>
					}
				</mat-form-field>
			</lvr-field>

			<!-- Remark Field (Freitextfeld für den Beginn der Beschäftigung fals Datum nicht genau) -->
			<lvr-field [label]="'client.career.remark' | transloco">
				<mat-form-field lvrInput>
					<input
						matInput
						formControlName="remarkOfTheCareerStage"
						[placeholder]="'client.career.remark_placeholder' | transloco"
					/>
					<mat-hint>{{ 'client.career.remark_hint' | transloco }}</mat-hint>
				</mat-form-field>
			</lvr-field>

			<!-- Zustand -->
			@let adminissionCtrl = form.get('admissionId');
			<lvr-field [label]="'client.career.admission' | transloco" lvrPadding [padHorizontal]="16" [padVertical]="0">
				<mat-form-field lvrInput>
					<mat-select
						formControlName="admissionId"
						[placeholder]="'base.field.select_please' | transloco"
						aria-required="true"
					>
						@if (participationStatuses().length <= 0) {
							<mat-option disabled>
								{{ 'base.field.no_suggestion' | transloco }}
							</mat-option>
						} @else {
							@for (status of participationStatuses(); track status.id) {
								<mat-option [value]="status.id">
									{{ status.remark }}
								</mat-option>
							}
						}
					</mat-select>
					@if (adminissionCtrl?.disabled) {
						<mat-hint> {{ 'client.career.not_editable' | transloco }}</mat-hint>
					}
				</mat-form-field>
			</lvr-field>
		</lvr-section-form>

		<p class="required-hint" lvrPadding [padHorizontal]="0" [padVertical]="16">
			{{ 'base.form.required' | transloco }}
		</p>

		<lvr-default-actions
			[disableSave]="form.invalid || !canEditCareersPermission()"
			[showLoading]="isLoading()"
			(save)="save()"
			(cancelSave)="cancel()"
		>
			<lvr-restore-actions entityType="career" [entityId]="draftId()"></lvr-restore-actions>
		</lvr-default-actions>
	</lvr-section>
</form>
